var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "v-videos"
  }, [_vm.source ? _c('video-player', {
    ref: "videoPlayer",
    attrs: {
      "source": _vm.source,
      "type": _vm.type
    },
    on: {
      "video-ended": _vm.onVideoEnded,
      "video-started": _vm.onVideoStart
    }
  }) : _vm._e(), _c('video-slider', {
    attrs: {
      "active-index": _vm.activeIndex,
      "status": _vm.status,
      "videos": _vm.videos
    },
    on: {
      "index-updated": _vm.onIndexUpdated,
      "play": _vm.onPlay,
      "stop": _vm.onStop
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }